import {
  apiRequest,
  cp3kUploadSK,
  cp3kDetail,
} from "../../../../../services/adapters/kepegawaian/cp3kService";

class DetailRepository {
  fetchUploadSk = async (query) => {
    return await apiRequest(
      "post",
      cp3kUploadSK,
      {
        body: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      cp3kDetail,
      {
        params: query,
      },
      true
    );
  };
}

export default DetailRepository;
